import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=599f36fb&scoped=true"
import script from "./Delivery.vue?vue&type=script&setup=true&lang=js"
export * from "./Delivery.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=599f36fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f36fb",
  null
  
)

export default component.exports